import { styled } from "styled-components";
import { MOBILE } from "../../constants/breakpoints";

export const SearchContainer = styled.div`
    display: flex;
    border-radius: 12px;
    border: 1px solid ${props => props.theme.tintsGray};
    gap: 8px;
    max-width: 300px;
    padding: 0px 24px;

    align-items: center;
    overflow: hidden;

    -webkit-transition: 0.5s;
    transition: 0.5s;
    /* background-color: ${(props) => props.theme.secondary}; */
    
    .input {
        width: 100%;
        border: none;
        height: 38px;
        border: none;
        outline: none;
        //styleName: Desktop/Body 2;
        font-family: 'TomatoGrotesk';
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;

    }

    @media (max-width: ${MOBILE}px) {
        max-width: 400px;
    }
`